"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WhiteBalanceOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29,6H3A1,1,0,0,0,2,7V25a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V7A1,1,0,0,0,29,6ZM28,24H4V8H28Z"/><path d="M11.52,19l.93-3.53c0-.15.09-.42.17-.78s.12-.64.14-.8c0,.13.06.4.14.79s.15.66.18.78L14,19h1.66l1.75-6.73H16l-.88,3.67c-.06.22-.12.51-.19.87s-.12.66-.15.9q0-.37-.15-.9c-.06-.34-.12-.6-.16-.77l-1-3.77H12.08l-1,3.77a7.12,7.12,0,0,0-.19.85c-.07.37-.11.64-.13.82-.07-.5-.18-1.09-.34-1.77l-.88-3.67H8.11L9.86,19Z"/><path d="M22.7,18.47A1.67,1.67,0,0,0,23.38,17a1.65,1.65,0,0,0-.29-1,1.52,1.52,0,0,0-.94-.54v0a1.18,1.18,0,0,0,.77-.47,1.64,1.64,0,0,0,.29-1,1.4,1.4,0,0,0-.66-1.29,4.12,4.12,0,0,0-2.13-.41H18.29V19h2.57A2.94,2.94,0,0,0,22.7,18.47Zm-3-5h.77a1.77,1.77,0,0,1,.91.17.57.57,0,0,1,.29.55.67.67,0,0,1-.26.59,1.6,1.6,0,0,1-.86.18h-.85Zm0,4.38V16.06h.91c.81,0,1.22.28,1.22.83a.83.83,0,0,1-.29.69,1.44,1.44,0,0,1-.89.23Z"/>';
var WhiteBalanceOutlineSVG = function WhiteBalanceOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.WhiteBalanceOutlineSVG = WhiteBalanceOutlineSVG;
WhiteBalanceOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(WhiteBalanceOutlineSVG);
exports.default = _default;